'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VideoForm = require('./components/VideoForm');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VideoForm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/video-form/index.js
// module id = 370
// module chunks = 1